<template>
  <div v-if="isDialogShow" class="registrationDialog">
    <div class="registrationDialog_box">
      <div class="close_box" @click="closeClick"></div>

      <div class="text5_img"></div>

      <div class="input_box">
        <div class="text_txt">
          热烈庆祝深圳写手智能科技公司 双子星软件“成语”“反抄袭”
          2022年5月20日正式上线运行
        </div>
        <div class="btn_box" @click="handelClick"></div>
        <div class="zifu_text">
          现在注册获赠{{ characterNum ? characterNum : 5000 }}字符
        </div>

        <div class="log_box"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { findUserRecommendCode } from "api/header";
export default {
  name: "registrationDialog",
  data() {
    return {
      isDialogShow: false,
      code: "",
      characterNum: "",
      discountMsg: "",
      isShowBtn: false,
      ishaveid: "",
    };
  },
  watch: {
    isDialogShow: {
      handler: function (val) {
        if (val) {
          this.getFindUserRecommendCode();
        }
      },
    },
  },
  methods: {
    handelClick() {
      this.isDialogShow = false;
      this.$emit("registerClick", true);
    },

    closeClick() {
      this.isDialogShow = false;
    },

    async getFindUserRecommendCode() {
      let user = JSON.parse(window.localStorage.getItem("vuex"));

      if (user.user_info) {
        this.isShowBtn = true;
        this.ishaveid = user.user_info.haveid;
      } else {
        this.isShowBtn = false;
        this.ishaveid = "";
      }
      const res = await findUserRecommendCode();
      // console.log(res);
      if (res.code != 200) {
        return this.$message({
          message: res.message,
        });
      }

      this.code = res.data.code;
      this.characterNum = res.data.characterNum;
      this.discountMsg = res.data.discountMsg;
    },

    copyClick(val) {
      let oInput = document.createElement("input");
      val == 1
        ? (oInput.value =
            "写手智能科技公司专属注册链接，点击  http://passport.writemall.com/register?code=" +
            this.code +
            "     " +
            this.discountMsg)
        : (oInput.value = this.code);
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.registrationDialog {
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;

  .registrationDialog_box {
    position: absolute;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 430px;

    padding-top: 60px;
    background: url("~assets/images/exclusive-registration/bgc.png") no-repeat;
    background-size: 100% 100%;
    .close_box {
      position: absolute;
      top: 35px;
      right: 15px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .text_img {
      margin: 0 auto 0;
      width: 296px;
      height: 124px;
      background: url("~assets/images/exclusive-registration/text6.png")
        no-repeat;
      background-size: 100% 100%;
    }

    .text5_img {
      margin: 0 auto 0;
      width: 350.9px;
      height: 124px;
      background: url("~assets/images/exclusive-registration/text8.png")
        no-repeat;
      background-size: 100% 100%;
    }

    .input_box {
      .registered,
      .preferential {
        margin-top: 30px;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;

        .text {
          width: 20%;
          text-align: center;
        }

        .content {
          display: flex;
          box-sizing: border-box;
          padding: 20px;
          background-color: #248eff;
          justify-content: space-between;
          align-items: center;
          width: 270px;
          height: 50px;
          border: 2px solid #fff;
          border-radius: 25px;

          .copy_text {
            cursor: pointer;
          }
        }
      }
    }

    .text_txt {
      padding: 35px 75px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 40px;
      text-shadow: 0px 0px 28px #1067e8;
    }

    .text_box {
      box-sizing: border-box;
      padding-right: 40px;
      margin-top: 15px;
      text-align: right;
      color: #fff;
      font-size: 16px;
    }

    .btn_box {
      margin: 30px auto 0;
      cursor: pointer;
      width: 244px;
      height: 84px;
      background: url("~assets/images/exclusive-registration/btn.png") no-repeat;
      background-size: 100% 100%;
    }

    .zifu_text {
      color: #fff;
      font-size: 19px;
      text-align: center;
      margin-top: 10px;
    }

    .zifu_text1 {
      padding: 20px;
      color: #fff;
      line-height: 1.5;
      font-size: 19px;
      text-align: center;
      margin-top: 40px;
    }

    .log_box {
      margin: 20px auto;

      width: 192px;
      height: 54px;
      background: url("~assets/images/exclusive-registration/log.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
